import account_types from "../../config/account_types";

export function accountTypeValidator(accountType) {
  if (!Object.values(account_types).includes(accountType)) {
    return "Select account type.";
  }
  return "";
}
